import { createAction } from "@reduxjs/toolkit";
import { NavPoint } from "@redux/navPoint/NavPoint";

export const refreshNavPoint = createAction<NavPoint>("navPoint/refresh");
